import axiosInstance from "api/axiosInstance";
import { toast } from "react-toastify";

export const messagePerDayChart = async ({
  startDate,
  endDate,
  accessToken,
  withHour
}) => {
  try {
    const response = await axiosInstance.post(
      "/business/analystics/messagePerDay",
      { startDate, endDate,withHour },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      const errorMessage = error.response.data?.error || error?.message;
      if (errorMessage) {
        toast.error(errorMessage);

      } else toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
    } else {
      // خطاهای مربوط به شبکه یا سرور
      toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
    }
    
  }
};
export const topUsersChart = async ({ startDate, endDate, accessToken }) => {
  try {
    const response = await axiosInstance.post(
      "/business/analystics/topUsers",
      { startDate, endDate },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      const errorMessage = error.response.data?.error || error?.message;
      if (errorMessage) {
        toast.error(errorMessage);
      } else toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
    } else {
      // خطاهای مربوط به شبکه یا سرور
      toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
    }
  }
};
export const wordCloudChart = async ({ startDate, endDate, accessToken }) => {
  try {
    const response = await axiosInstance.post(
      "/business/analystics/wordcloud",
      { startDate, endDate },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      const errorMessage = error.response.data?.error || error?.message;
      if (errorMessage) {
        toast.error(errorMessage);
      } else toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
    } else {
      // خطاهای مربوط به شبکه یا سرور
      toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
    }
  }
};
